import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "../../../styles/Timeline/EventsSlider.scss";
import { useEventsSlider } from "../../../hooks/useEventsSlider";
const EventsSlider = ({ events }) => {
    const { swiperRef, sliderContainerRef } = useEventsSlider(events);
    return (_jsxs("div", { className: "events-slider", ref: sliderContainerRef, children: [_jsx("div", { ref: swiperRef, className: "swiper", children: _jsx("div", { className: "swiper-wrapper", children: events.map((event, index) => (_jsx("div", { className: "swiper-slide", children: _jsxs("div", { className: "event-card", children: [_jsx("h3", { className: "event-year", children: event.year }), _jsx("p", { className: "event-text", children: event.text })] }) }, `${event.year}-${index}-${event.id || ""}`))) }) }), _jsx("div", { className: "swiper-button-prev" }), _jsx("div", { className: "swiper-button-next" })] }));
};
export default EventsSlider;
